export const Laurel = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4"
    strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M12 21c-3.4 0-6.6-2.7-6.6-7.4C5.4 9.6 7.5 6.1 10.4 4.2" />
    <path d="M12 21c3.4 0 6.6-2.7 6.6-7.4C18.6 9.6 16.5 6.1 13.6 4.2" />
    <path d="M8.1 8.2c1.4.1 2.4.9 2.8 2.2" />
    <path d="M6.6 11.7c1.4 0 2.5.7 3 2" />
    <path d="M6.5 15.3c1.4-.2 2.6.3 3.2 1.6" />
    <path d="M15.9 8.2c-1.4.1-2.4.9-2.8 2.2" />
    <path d="M17.4 11.7c-1.4 0-2.5.7-3 2" />
    <path d="M17.5 15.3c-1.4-.2-2.6.3-3.2 1.6" />
    <path d="M12 21v-2" />
  </svg>
);
